var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcLogoDinnerClub = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 42,
    fill: "none",
    viewBox: "0 0 64 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069AA",
    d: "M64 38.4c0 1.988-1.694 3.6-3.783 3.6H3.783C1.693 42 0 40.388 0 38.4V3.6C0 1.612 1.694 0 3.783 0h56.434C62.307 0 64 1.612 64 3.6v34.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34495E",
    d: "M64 27.591H0v9.001h64v-9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.125 12.941H33.784c-.577 0-1.044-.466-1.044-1.043 0-.576.467-1.043 1.044-1.043h12.34c.577 0 1.044.466 1.044 1.043s-.467 1.043-1.043 1.043zM56.536 17.274H33.784c-.577 0-1.044-.467-1.044-1.043 0-.577.467-1.044 1.044-1.044h22.752c.577 0 1.044.467 1.044 1.044 0 .576-.467 1.043-1.044 1.043zM10.191 14.326c0 2.017 1.236 3.708 2.993 4.359V9.967c-1.756.65-2.993 2.342-2.993 4.36zM19.493 14.326c0-2.017-1.236-3.708-2.993-4.358v8.717c1.757-.65 2.993-2.407 2.993-4.359z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.349 7.643l-.016-.018c-.111-.068-.223-.133-.337-.197-1.015-.587-2.155-.97-3.34-1.11-.315-.058-.629-.059-.942-.059H14.81c-4.489 0-8.132 3.318-8.132 8.132 0 1.952.716 3.774 1.952 5.14l.107.108c1.492 1.687 3.688 2.754 6.138 2.754h3.773c4.424 0 8.457-3.578 8.457-8.002-.04-2.952-1.572-5.34-3.756-6.748zm-8.443 14.169c-4.135 0-7.486-3.352-7.486-7.486S10.77 6.84 14.906 6.84c4.134 0 7.486 3.352 7.486 7.486s-3.352 7.486-7.486 7.486z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcLogoDinnerClub, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_logo_dinner_club.b24bdff3.svg";
export { ForwardRef as ReactComponent };